export const boxSlideShowMetaData = {
    isRepeatable: false,
    enforceContainerChildLimitsByWidth: false,
    enforceContainerChildLimitsByHeight: false
}
